import React from "react";
import styled from "styled-components";
import KakaoAdfit1 from "../KakaoAdfit/KakaoAdfit1";
import KakaoAdfit2 from "../KakaoAdfit/KakaoAdfit2";
import KakaoAdfit3 from "../KakaoAdfit/KakaoAdfit3";
import KakaoAdfit4 from "../KakaoAdfit/KakaoAdfit4";
import { isMobile } from "../common/style";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Icon } from "../common/image/game/icon.svg";

const StartPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Center>
      <h1>똥 피하기 게임</h1>
      <Container>
        <SiteDiv>
          <Icon className="icon" />
        </SiteDiv>
        <GameDiv>
          <h2>게임 방법</h2>
          <h3>
            [시작하기] 버튼을 누르면 게임이 시작됩니다. <br />
            하트는 총 5개로 하트가 다 사라지면 게임이 종료됩니다.
            <br /> 똥을 한 번 맞을 때마다 하트가 1개씩 사라집니다.
            <br />
            {window.matchMedia("(max-width: 830px)").matches
              ? "캐릭터 아래 버튼을 눌러 좌우로 움직일 수 있습니다."
              : "키보드 화살표 키를 눌러 좌우로 움직일 수 있습니다."}
          </h3>
        </GameDiv>
        <button onClick={() => navigate("/game")}>시작 하기</button>
      </Container>
      <KakaoAdfitDiv1>
        <KakaoAdfit1 />
      </KakaoAdfitDiv1>
      <KakaoAdfitDiv2>
        <KakaoAdfit2 />
      </KakaoAdfitDiv2>
      <KakaoAdfitDiv>
        <KakaoAdfit3 />
        <KakaoAdfit4 />
      </KakaoAdfitDiv>
    </Center>
  );
};

export default StartPage;

const Center = styled.div`
  display: flex;
  position: fixed;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  left: 0;
  right: 0;
  transition: 0.5s;

  h1 {
    font-size: 27px;
    font-weight: 700;
    line-height: 150%;
    font-family: GmarketSansBold;
    color: #8abbe9;

    margin-top: 63px;
    margin-bottom: 50px;

    ${isMobile} {
      font-size: 22px;
      margin-top: 35px;
      margin-bottom: 20px;
    }
  }
`;

const Container = styled.div`
  width: 800px;
  height: 530px;

  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right: 8px solid #83c1fa;
  border-left: 8px solid #83c1fa;
  border-bottom: 8px solid #83c1fa;
  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.1);

  ${isMobile} {
    width: 300px;
    height: 380px;
    border-right: 4px solid #83c1fa;
    border-left: 4px solid #83c1fa;
    border-bottom: 4px solid #83c1fa;
  }

  button {
    width: 210px;
    height: 75px;

    border-radius: 100px;
    border: 3px solid #83c1fa;
    background: #fff;

    color: #8bb9e4;
    text-align: center;
    font-family: GmarketSansBold;
    font-size: 25px;
    font-weight: 700;
    margin-top: 26px;

    cursor: pointer;

    &:hover {
      background: #e2effc;
    }

    ${isMobile} {
      margin-top: 10px;
      width: 150px;
      height: 45px;
      border: 2px solid #83c1fa;
      font-size: 20px;
    }
  }
`;

const SiteDiv = styled.div`
  width: 100%;
  background: #83c1fa;

  .icon {
    width: 99.222px;
    float: right;
    padding: 8px;

    ${isMobile} {
      width: 75px;
      padding: 2px;
    }
  }
`;

const GameDiv = styled.div`
  width: 560px;
  border-radius: 50px;
  border: 3px dashed #83c1fa;
  margin-top: 50px;
  padding: 35px 10px;

  ${isMobile} {
    width: 220px;
    border-radius: 30px;
    border: 2px dashed #83c1fa;
    margin-top: 15px;
    padding: 10px 5px;
  }

  h2 {
    color: #8bb9e4;
    text-align: center;
    font-family: GmarketSansBold;
    font-size: 25px;
    font-weight: 700;
    margin-bottom: 16px;

    ${isMobile} {
      font-size: 19px;
      margin-bottom: 10px;
    }
  }

  h3 {
    color: #aacbe9;
    text-align: center;
    font-family: GmarketSansBold;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 39px;

    ${isMobile} {
      font-size: 14px;
      line-height: 25px;
      word-break: keep-all;
    }
  }
`;

const KakaoAdfitDiv1 = styled.div`
  margin-top: 50px;
  margin-right: 1000px;
  position: absolute;
`;

const KakaoAdfitDiv2 = styled.div`
  margin-top: 50px;
  margin-left: 1000px;
  position: absolute;
`;

const KakaoAdfitDiv = styled.div`
  position: relative;
  margin-top: 10px;
`;
